import { HttpService } from '../services/http';
import { FormService } from '../services/form';

function SurveyComponent() {
  const formService = new FormService();
  const httpService = new HttpService();

  function init() {
    const params = new URLSearchParams(window.location.search);
    if (params.has('admin')) {
      addSurveyDate();
    }

    formService.setValidators('form#survey-form');
  }

  /**
   * Adds survey date field and event listener so admins can copy/paste testimonials from one of our other projects.
   */
  function addSurveyDate() {
    const surveyDate = document.querySelector('#surveyDate');
    surveyDate.addEventListener('input', surveyDateValidator);
    surveyDate.setAttribute('required', 'required');
    surveyDate.closest('fieldset').classList.remove('hide');
  }

  /**
   * Validates the value of the survey date field.
   *
   * If the value is not a valid date or string, such as "3 days ago", this method sets the custom validity error. If
   * the value is valid, this method displays the parsed date in the DOM and clears the custom validity error.
   *
   * @param {Event} event the event
   */
  function surveyDateValidator(event) {
    const date = parseSurveyDateValue(event.target);
    const timestampHiddenField = document.querySelector('#surveyTimestamp');
    const parsedTimestampOutput = document.querySelector('#parsedTimestampOutput');

    if (!isNaN(date.getTime())) {
      timestampHiddenField.value = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
      parsedTimestampOutput.textContent = timestampHiddenField.value;
      document.querySelector('#parsedTimestamp').classList.remove('hide');
      document.querySelector('#surveyDate').setCustomValidity('');
    } else {
      timestampHiddenField.value = 'Invalid Date';
      parsedTimestampOutput.textContent = timestampHiddenField.value;
      document.querySelector('#parsedTimestamp').classList.remove('hide');
      document.querySelector('#surveyDate').setCustomValidity('Invalid format for survey date');
    }
  }

  /**
   * Parses the surveyDate input and returns a Date object.
   *
   * The surveyDate field can accept the following input values:
   *   MM/DD/YYYY
   *   x weeks ago
   *   x days ago
   *   x minutes ago (simply returns the current date)
   *   x hours ago (simply returns the current date)
   *
   * @param {Element} surveyDate the surveyDate field
   */
  function parseSurveyDateValue(surveyDate) {
    const formattedDate = surveyDate.value.match(/(\d+) (minute|hour|day|week)/i);
    if (formattedDate) {
      let date = new Date();
      switch (formattedDate[2]) {
        case 'week':
          date.setDate(date.getDate() - 7 * formattedDate[1]);

          return date;
        case 'day':
          date.setDate(date.getDate() - 1 * formattedDate[1]);

          return date;
        case 'minute':
        case 'hour':
        default:
          return date;
      }
    } else {
      return new Date(surveyDate.value);
    }
  }

  /**
   * Structures the form data for the POST request.
   */
  function getFormData() {
    let body = {
      privacy_stats: document.querySelector('[name=ratingService]:checked').value,
      convenience_stats: document.querySelector('[name=ratingConvenience]:checked').value,
      speed_stats: document.querySelector('[name=ratingSpeed]:checked').value,
      comment: document.querySelector('[name=surveyDetails]').value,
    };

    const surveyTimestamp = document.querySelector('#surveyTimestamp').value;
    if (surveyTimestamp) {
      body.timestamp = surveyTimestamp;
    }

    return body;
  }

  /**
   * Shows the success message once the form has been submitted.
   */
  function showSuccessMessage() {
    document.querySelector('#survey-container').classList.add('hide');
    document.querySelector('#success-container').classList.remove('hide');
    window.scrollTo(0, 0);
  }

  /**
   * Displays back-end error if the POST request fails.
   *
   * @param {Response} error the response from the back-end
   */
  function showBackendError(error) {
    document.querySelector('#survey-form-error').textContent =
      error.message ?? 'Whoops, an error occurred. Please try again later';
    document.querySelector('#survey-form-error').classList.remove('hide');
  }

  init();

  return {
    /**
     * Submits the survey.
     *
     * @param {Event} event the click event from the submit button
     */
    submitSurvey: function (event) {
      event.preventDefault();

      const form = document.querySelector('#survey-form');
      if (!form.checkValidity()) {
        formService.validateAllInputs('form#survey-form');
        form.querySelector('#survey-form-error').classList.remove('hide');

        return;
      }

      form.querySelector('#submit-survey-button').setAttribute('disabled', 'disabled');
      form.querySelector('#survey-form-error').classList.add('hide');

      httpService
        .post(`${process.env.API_URL}/api/v1/survey`, getFormData())
        .then(() => showSuccessMessage())
        .catch((error) => showBackendError(error))
        .finally(() => form.querySelector('#submit-survey-button').removeAttribute('disabled'));
    },
  };
}

window.survey = new SurveyComponent();
